export default "__VITE_ASSET__oJrLylS8__"